// removed by extract-text-webpack-plugin
module.exports = {"content":"ValidateRandomization__content__1lg2C","parentContainer":"ValidateRandomization__parentContainer__1yCfn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ValidateRandomization/ValidateRandomization.css
// module id = 866
// module chunks = 0